module.exports = __webpack_public_path__ + "static/pic03-bb108c8a431506f48e7a75e6afd910f8.jpg";